<template>
  <div class="balance-detail">
    <pageHeader title="余额明细" />

    <div class="container-top">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无更多数据"
        @load="onLoad"
      >
        <div class="balance-item" v-for="(item, i) in balanceList" :key="i">
          <div class="balance-title">
            <h1>{{item.tradeTypeName}}</h1>
            <span>{{item.createTimeStr}}</span>
          </div>
          <div class="balance-amount">
            <span>交易后金额（￥{{item.afterMoney}}）</span>
            <span>交易金额 <em class="em-string">{{item.tradeMoney}}</em></span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      balanceList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {
    ...mapGetters(["userInfo", "uuid"]),
  },
  methods: {
    async onLoad() {
      const { data, totalCount } = await this.balanceListQr();
      this.balanceList = [...this.balanceList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize)
      console.log(this.totalPage, this.totalCount, 'totalPage')
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    async balanceListQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/user/user/getAccountLogList.htm",
          "post",
          {
            uuid: this.uuid,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (err) {
        this.$toast(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.balance-detail {
  .container-top {
    width: 100%;
    height: 700px;
    background: url("~@/assets/images/balance-bg.png");
    background-size: 100% 100%;
    padding: 50px 30px;

    .balance-item {
      width: 690px;
      height: 192px;
      background: #ffffff;
      box-shadow: 0px 0px 40px 0px rgba(171, 145, 134, 0.3),
        0px 0px 10px 0px rgba(149, 142, 139, 0.08);
      border-radius: 16px;
      padding: 30px;
      margin-bottom: 20px;

      .balance-title {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 40px;

        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          line-height: 45px;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #8f8f8f;
          line-height: 33px;
        }
      }
      .balance-amount {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          line-height: 37px;
        }
        .em-string {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #ff7a3e;
          line-height: 56px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/balance/index.vue